<template>
    <div class="performanceDispatchParkAppointCard" v-loading="cardLoading">
        <el-card
            shadow="never"
            v-for="(item, index) in multipleSelection"
            :key="index"
        >
            <div slot="header" class="clearfix">
                <div class="box-card-header">
                    <span class="card-header-title">{{ item.whName }}</span>
                    <el-date-picker
                        v-model="item.bookingDate"
                        type="date"
                        placeholder="选择预约日期"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                        style="width: 130px"
                        @change="(val) => datePickerChange(item)"
                    ></el-date-picker>
                </div>
                <div v-if="item.bookingDate">
                    <div v-if="!item.lineInfo.lineName && item.timeSeparate && !cardLoading">
                        <span class="header-item mg-r">最小预约间隔时间：<span class="value">{{ item.timeSeparate }}小时</span></span>
                        <span class="header-item">可预约最早时间：<span class="value">{{ getEarliestBookTime(item, index) }}</span></span>
                    </div>
                    <div v-if="item.lineInfo.lineName">
                        <div class="header-item mg-r">线路时刻：<span class="value">{{ item.lineInfo.lineName }}</span></div>
                        <div class="header-item">可预约时段：<span class="value">{{ item.lineInfo.lineTime }}</span></div>
                    </div>
                    <div v-if="item.overFlag">
                        <div class="red-color">(线路超方，放开其他可预约时段，如您想继续按线路预约请联系仓库增加可作业量)</div>
                    </div>
                </div>
            </div>
            <el-table :data="item.radioList">
                <el-table-column label="选择" width="70px">
                    <template slot-scope="scope">
                        <el-radio
                            v-model="item.radio"
                            :label="scope.$index"
                            :disabled="validateTime(scope.row, index)"
                            @change="(val) => radioChange(item)"
                            >&nbsp;</el-radio
                        >
                    </template>
                </el-table-column>
                <el-table-column
                    label="可预约时间段"
                    prop="slotName"
                    align="center"
                    width="150px"
                >
                    <template slot-scope="scope">
                        <el-tooltip
                            class="item"
                            effect="dark"
                            content="可预约时间段"
                            placement="top"
                        >
                            <span>{{ scope.row.slotName }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column
                    label="已预约方量"
                    prop="totalQtyBooking"
                    min-width="76"
                    align="center"
                >
                    <template slot-scope="scope">
                        <el-tooltip
                            class="item"
                            effect="dark"
                            content="已预约方量"
                            placement="top"
                        >
                            <span>{{ scope.row.totalQtyBooking }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column
                    label="当前预约百分比"
                    prop="workPercent"
                    min-width="90"
                    align="center"
                >
                    <template slot-scope="scope">
                        <el-tooltip
                            class="item"
                            effect="dark"
                            content="当前预约百分比"
                            placement="top"
                        >
                            <span>{{ workPercent(scope.row.workPercent) }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column
                    label="可预约方量"
                    prop=""
                    min-width="70"
                    align="center"
                >
                    <template slot-scope="scope">
                        <el-tooltip
                            class="item"
                            effect="dark"
                            content="可预约方量"
                            placement="top"
                        >
                            <span>{{ scope.row.totalQty - scope.row.totalQtyBooking }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
    </div>
</template>
<script>
import dayjs from 'dayjs';
export default {
    name: 'performanceDispatchParkAppointCard',
    props: {
        multipleSelection: {
            type: Array,
            default () { return []; }
        }
    },
    data () {
        return {
            pickerOptions: { // 小于当前日期置灰
                disabledDate (time) {
                    return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
                }
            },
            currentHour: dayjs().hour(),
            cardLoading: false
        };
    },
    computed: {
        workPercent () {
            return function (data) {
                return (data * 100).toFixed(2) + '%';
            };
        },
        // 可预约时间段小于当前日期时 按钮置灰
        validateTime () {
            return function (radioList, index) {
                const { bookingDate, earliestBookTime, lineInfo, abilityTimeCodesCurrent } = this.multipleSelection[index];
                const time = radioList.slotName.split('-')[0];
                const date = bookingDate + ' ' + time;
                if (lineInfo && lineInfo.lineName && Array.isArray(abilityTimeCodesCurrent)) {
                    // 有配置线路，禁用不可预约时间段
                    return !abilityTimeCodesCurrent.includes(radioList.abilityTimeCode);
                } else if (!lineInfo.lineName && earliestBookTime) {
                    // 未配置线路且存在最早可预约时间（园区预约规则），则 可预约时间段 小于 可预约最早时间 时按钮置灰。否则 可预约时间段 小于 当前时间 按钮置灰
                    return dayjs(date).unix() < dayjs(earliestBookTime).unix();
                } else {
                    // 未配置线路且无最早可预约时间，则小于当前时间置灰
                    return bookingDate === dayjs().format('YYYY-MM-DD') ? dayjs(date).unix() < dayjs().unix() : false;
                }
            };
        }
    },
    watch: {
        currentHour () {
            if (this.multipleSelection.length) {
                this.multipleSelection.forEach((item, index) => {
                    item.timeSeparate && this.getEarliestBookTime(item, index);
                });
            }
        }
    },
    methods: {
        // 可预约最早时间
        getEarliestBookTime (data, index) {
            let currentTime = dayjs();
            // 如果当前分钟或秒不为零，则小时数加一
            if (currentTime.minute() !== 0 || currentTime.second() !== 0) {
                currentTime = currentTime.add(1, 'hour');
            }
            // 若仓库有配置最小时间间隔，则加上时间间隔并取整点
            const earliestBookTime = data.timeSeparate ? currentTime.add(data.timeSeparate, 'hour').startOf('hour').format('YYYY-MM-DD HH:mm') : '';
            this.$set(this.multipleSelection[index], 'earliestBookTime', earliestBookTime);
            return earliestBookTime;
        },
        /**
         * @description 选择预约日期回调
         * @param {Object} row 对应左侧选中的表格数据
         */
        datePickerChange (row) {
            this.$emit('datePickerChange', row);
        },

        /**
         * @description 选择单选框时间点回调
         * @param {Object} row 对应左侧选中的表格数据
         */
        radioChange (row) {
            this.$emit('radioChange', row);
        }
    }
};

</script>
<style lang="less">
.performanceDispatchParkAppointCard {
    .el-card:not(:last-child) {
        margin-bottom: 12px;
    }
    .el-card__header {
        padding: 8px;
    }
    .card-header-title {
        font-size: 14px;
        color: #666;
        margin-right: 8px;
    }
    .header-item {
        font-size: 13px;
        color: #00BCBF;
        .value {
            color: red;
        }
    }
    .red-color {
        font-size: 13px;
        color: red;
    }
    .mg-r{
        margin-right: 10px;
    }
    .el-card__body {
        padding: 10px 15px;
    }
    .el-table {
        border-top: 1px solid #ebeef5;
        border-left: 1px solid #ebeef5;
        border-right: 1px solid #ebeef5;
        // .el-table__header-wrapper {
        //     display: none;
        // }
        .cell {
            padding-left: 20px;
            padding-right: 20px;
        }
    }
}
</style>
